import React from 'react';
import AdvWorkflow from '../../../AdvWorkflow/AdvWorkflowContainer';
import AccountStep from '../../../AccountsWorkflow/Steps/AccountsStep/AccountsStepContainer';

interface Props {
  branch: number[];
  workflowId: string;
}

export const AccountsWorkflow = ({ branch, workflowId }: Props) => (
  <AdvWorkflow branch={branch} workflowId={workflowId} steps={[AccountStep]} />
);
